// src/Components/Main/SubComponents/ExportClientsModal.jsx
import React, { useState } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, Stack
} from '@mui/material';
import AutocompleteSelectFilter from '../Widgets/AutocompleteSelectFilter/AutocompleteSelectFilter.jsx';
import { useTranslation } from 'react-i18next';
import styles from './ExportModal.module.scss';

const ExportClientsModal = ({
    open, onClose, onExport,
    subAccountants, accountingManagementType, activeOption,
    defaultFilters        // {subAcc, accMgmt, active, date}
}) => {
    const { t, i18n } = useTranslation();
    const dir = i18n.dir()
    /* local, modal-only filter state ---------------------------- */
    const [subAcc, setSubAcc] = useState(defaultFilters.subAcc);
    const [accMgmt, setAccMgmt] = useState(defaultFilters.accMgmt);
    const [active, setActive] = useState(defaultFilters.active);
    const [date, setDate] = useState(defaultFilters.date);
    const [reportType, setReportType] = useState(defaultFilters.reportingType);
    const [vatStatuses, setVatStatuses] = useState(defaultFilters.vatStatuses || []);
    const [advanceStatuses, setAdvanceStatuses] = useState(defaultFilters.advanceStatuses || []);

    /* NEW – options for reporting frequency */
    const reportingOptions = [
        { value: 'חודשי', label: 'חודשי' },
        { value: 'דו חודשי', label: 'דו חודשי' },
    ];
    const reportStatusOptions = [
        { value: 'reported', label: t('reported') },
        { value: 'notReported', label: t('notReported') },
        { value: 'notReportedperiod', label: t('notReportedperiod') },
        { value: 'notForReport', label: t('notForReport') },
    ];
    /* handlers -------------------------------------------------- */
    const handleDateChange = (value, part) => {
        const d = new Date(date);
        if (part === 'year') d.setUTCFullYear(value.getUTCFullYear());
        if (part === 'month') d.setUTCMonth(value.getUTCMonth());
        setDate(d);
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={false}
            dir={dir}
            PaperProps={{
                className: styles.paper,
                sx: {
                    maxWidth: 720,
                    width: 'min(720px, calc(100vw - 32px))',
                },
            }}
            BackdropProps={{ sx: { background: 'rgba(20, 30, 43, 0.45)', backdropFilter: 'blur(6px)' } }}
        >
            <DialogTitle className={styles.header}>{t('exportClients')}</DialogTitle>
            <DialogContent className={styles.scroll}>
                <Stack spacing={2}>
                    <div className={styles.filtersGrid}>
                        <div className={styles.gridField}>
                            <AutocompleteSelectFilter
                                options={subAccountants}
                                selectedValues={subAcc}
                                onChange={(e, v) => setSubAcc(v)}
                                label={t('SubAccountant')}
                                placeholder={t('SubAccountant')}
                                direction={dir}
                            />
                        </div>
                        <div className={styles.gridField}>
                            <AutocompleteSelectFilter
                                options={accountingManagementType}
                                selectedValues={accMgmt}
                                onChange={(e, v) => setAccMgmt(v)}
                                label={t('AccountManagement')}
                                placeholder={t('AccountManagement')}
                                direction={dir}
                            />
                        </div>
                        <div className={styles.gridField}>
                            <AutocompleteSelectFilter
                                options={activeOption}
                                selectedValues={active}
                                onChange={(e, v) => setActive(v)}
                                label={t('ActiveInactiveClients')}
                                placeholder={t('ActiveInactiveClients')}
                                isMultiple={false}
                                direction={dir}
                            />
                        </div>
                        <div className={styles.gridField}>
                            <AutocompleteSelectFilter
                                options={reportingOptions}
                                selectedValues={reportType}
                                onChange={(e, v) => setReportType(v)}
                                label={t('MonthlyBiMonthly')}
                                placeholder={t('MonthlyBiMonthly')}
                                isMultiple={false}
                                direction={dir}
                            />
                        </div>
                        <div className={styles.gridField}>
                            <AutocompleteSelectFilter
                                options={reportStatusOptions}
                                selectedValues={vatStatuses}
                                onChange={(e, v) => setVatStatuses(v)}
                                label={t('VATReport')}
                                placeholder={t('VATReport')}
                                direction={dir}
                            />
                        </div>
                        <div className={styles.gridField}>
                            <AutocompleteSelectFilter
                                options={reportStatusOptions}
                                selectedValues={advanceStatuses}
                                onChange={(e, v) => setAdvanceStatuses(v)}
                                label={t('AdvanceTaxReport')}
                                placeholder={t('AdvanceTaxReport')}
                                direction={dir}
                            />
                        </div>
                    </div>
                </Stack>
            </DialogContent>

            <DialogActions className={styles.actions}>
                <Button
                    className={styles.cancel}
                    variant="contained"
                    disableElevation
                    onClick={onClose}
                >
                    {t('cancel')}
                </Button>
                <Button
                    className={styles.save}
                    variant="contained"
                    disableElevation
                    data-testid="export-download-button"
                    onClick={() =>
                        onExport({
                            subAcc,
                            accMgmt,
                            active,
                            date,
                            reportingType: reportType,
                            vatStatuses,
                            advanceStatuses
                        })}
                >
                    {t('download')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ExportClientsModal;
